module.exports = __webpack_public_path__ + "static/img/Nuevo_Inca_fondo_opacidad.cef71662.png";